import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { renderSkeletonTable } from "../../context/Customfunction";
import { SetPopupReducerData } from "../../store/reducer/PopupReducer";
import CustomTable from "../../ui/custom-table";
import {
  deleteCameralistingApiId,
  fetchCameraApi,
  fetchCameralistingApi,
} from "../../api/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function CameraListing() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [camera, setCamera] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // Debounce by 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const fetchCamera = async () => {
    setLoading(true);
    try {
      const page = pagination.pageIndex + 1;
      const limit = pagination.pageSize;
      const search = debouncedSearch;
      const data = await fetchCameralistingApi(
        page,
        limit,
        search,
        user_id,
        organization_id
      );
      if (data?.data?.status === true) {
        setCamera(data?.data?.data?.data || []);
        setTotalRows(data?.data?.data?.total || 0);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCamera();
  }, [pagination, debouncedSearch]);

  useEffect(() => {
    if (showModal === false) {
      fetchCamera();
    }
  }, [showModal, debouncedSearch]);

  const columns = useMemo(
    () => [
      { accessorKey: "camera_name", header: "Camera Name" },
      { accessorKey: "camera_type_name", header: "Camera Type" },
      {
        accessorKey: "is_auto_enabled",
        header: "Audio Status",
        Cell: ({ cell }) => (cell.getValue() ? "Enabled" : "Disabled"),
      },
      { accessorKey: "no_of_channels", header: "Channles" },
      { accessorKey: "public_static_ip", header: "IP" },
      { accessorKey: "location", header: "Location" },
    ],
    []
  );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDCAMERA",
        showModal: true,
      })
    );
  };

  const handleEdit = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDCAMERA",
        showModal: true,
        data: row._id,
      })
    );
  };

  const handleDelete = async (row) => {
    try {
      const data = await deleteCameralistingApiId(
        row?._id,
        user_id,
        organization_id
      );
      if (data) {
        toast("deleted Successfully!!");
        fetchCamera();
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const handleView = (row) => {
    localStorage.setItem("rtsp_url", row?.rtsp_url);
    navigate(`/setsection/${row?._id}`);
  };

  return (
    <>
      <aside className="mainSection">
        <CustomTable
          columns={columns}
          data={camera}
          loading={loading}
          onAddClick={handleAddClick}
          addButtonLabel="Add Camera"
          onEdit={handleEdit}
          showActions={true}
          onDelete={handleDelete}
          // onView={handleView}
          // showViewButton={true}
          pagination={pagination}
          onPaginationChange={(updater) => {
            setPagination((prev) => {
              const newPagination =
                typeof updater === "function"
                  ? updater(prev)
                  : { ...prev, ...updater };
              return newPagination;
            });
          }}
          rowCount={totalRows}
          onSearchChange={(e) => {
            setSearchTerm(e.target.value);
            setPagination({ pageIndex: 0, pageSize: 10 }); // Reset pagination on search
          }}
        />
      </aside>
    </>
  );
}

export default CameraListing;
